// ReferralCard — surfaces the user's referral code + share link + counter.
// Drop into Profile (when isMe) and Wallet pages.
import { useEffect, useState } from "react";
import { Copy, Users, Trophy } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function ReferralCard({ compact = false }) {
  const [r, setR] = useState(null);

  useEffect(() => {
    api.get("/me/referral").then(({ data }) => setR(data)).catch(() => setR(null));
  }, []);

  if (!r) return null;

  const copy = (txt, label = "Link") => {
    navigator.clipboard?.writeText(txt);
    toast.success(`${label} copied`);
  };

  return (
    <div className="border border-nexus-cyan/30 bg-gradient-to-r from-nexus-cyan/10 via-transparent to-nexus-gold/10 p-4 space-y-3" data-testid="referral-card">
      <div className="flex items-center gap-2">
        <Users className="w-4 h-4 text-nexus-cyan" />
        <div className="label-eyebrow text-nexus-cyan">// invite & earn</div>
      </div>
      {!compact && (
        <p className="text-xs text-white/70 leading-relaxed">
          Share your code. When a new member signs up with your link, you instantly get <strong className="text-nexus-cyan">+{r.xp_per_signup} XP</strong> toward your next level. If they upgrade to Studio tier, you <em>both</em> also get <strong className="text-nexus-gold">+{r.studio_bonus_nx ?? 500} NX</strong> to your wallets, plus you get another <strong className="text-nexus-cyan">+{r.studio_bonus_xp ?? 1000} XP</strong>.
        </p>
      )}
      <div className="flex items-center gap-2 flex-wrap">
        <div className="font-display tracking-[0.4em] text-xl text-nexus-cyan bg-nexus-obsidian/60 px-3 py-2 border border-nexus-cyan/40" data-testid="referral-code">{r.code}</div>
        <button onClick={() => copy(r.code, "Code")} className="btn-ghost text-[10px]" data-testid="copy-referral-code">
          <Copy className="w-3 h-3" /> Code
        </button>
        <button onClick={() => copy(r.link, "Invite link")} className="btn-ghost text-[10px]" data-testid="copy-referral-link">
          <Copy className="w-3 h-3" /> Link
        </button>
      </div>
      <div className="flex items-center gap-4 text-[11px] text-white/60 pt-2 border-t border-white/10">
        <span className="flex items-center gap-1"><Users className="w-3 h-3 text-nexus-cyan" /> {r.count} referred</span>
        <span className="flex items-center gap-1"><Trophy className="w-3 h-3 text-nexus-gold" /> {r.xp_earned} XP earned</span>
      </div>
    </div>
  );
}
